import { HttpMethod } from '../components/Common/useFetch';
import { RequestOptions } from '../components/Common/useRequest';
import useUserRequest from '../components/Common/useUserRequest';
import { useSelectedBusiness } from '../components/UserAccess/useSelectedBusiness';

export interface BulkRemoveOrdersRequest {
  orderIds: string[];
}

export interface RemovedOrder {
  id: string;
  number: string;
}

export interface FailedOrderRemoval {
  id: string;
  number: string;
  reason: string;
}

export interface BulkRemoveOrdersResponse {
  removed: RemovedOrder[];
  failed: FailedOrderRemoval[];
}

const useBulkRemoveOrders = (options?: RequestOptions<BulkRemoveOrdersResponse>) => {
  const business = useSelectedBusiness();

  return useUserRequest<BulkRemoveOrdersRequest, BulkRemoveOrdersResponse>({
    path: `/api/businesses/${business.id}/orders`,
    method: HttpMethod.DELETE,
  }, options);
};

export default useBulkRemoveOrders;
